import LiquidText, { liquidTone } from './LiquidText';
import ProdutoDocumentacaoLoteModal from './ProdutoDocumentacaoLoteModal';
import './ProdutosQuimicosPainel.css';
import { LiquidDialog } from './LiquidUI';
import { OrcamentoIcon } from './OrcamentoUI';
import ProdutoDocumentacaoModal from './ProdutoDocumentacaoModal';
import DeleteIcon from './DeleteIcon';
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import './EquipmentDialogs.css';

/* ============================================================
   PRODUTOS QUÍMICOS — gestão no Sistema Integrado
   (Req. Legais → Evidências → pasta FDS)

   O inventário que os trabalhadores preenchem no telemóvel. Aqui o
   escritório junta a FDS e a ficha técnica de cada produto — os PDF ficam
   nesta mesma pasta, como evidências, ligados ao produto — e apaga os
   duplicados. Os PDF que já estavam na pasta sem produto ligam-se a um
   produto existente ou dão origem a um novo.
   ============================================================ */

const DOC_LABEL = { fds: 'FDS', ficha_tecnica: 'Ficha técnica' };
const fmtData = (d) => (d ? new Date(d).toLocaleDateString('pt-PT') : '—');
const DIACRITICOS = new RegExp(`[${String.fromCharCode(0x300)}-${String.fromCharCode(0x36f)}]`, 'g');
const normalizar = (s) => String(s || '').normalize('NFD').replace(DIACRITICOS, '').toLowerCase();
// Título "FDS — X" / "Ficha Técnica — X": de que tipo é e de que produto
const tipoPeloTitulo = (t) => (/^\s*ficha\s+t[ée]cnica/i.test(t || '') ? 'ficha_tecnica' : 'fds');
const nomePeloTitulo = (t) => String(t || '').replace(/^\s*(FDS|Ficha\s+T[ée]cnica)\s*[—-]\s*/i, '').trim();

async function abrirBlob(url) {
    try {
        const r = await api.get(url, { responseType: 'blob' });
        const obj = window.URL.createObjectURL(r.data);
        window.open(obj, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(obj), 60000);
    } catch { alert('Não foi possível abrir.'); }
}
const abrirEvidencia = (id) => abrirBlob(`/conformidade-evidencias/${id}/ficheiro`);

/* ---------- Novo / editar produto ---------- */
function ProdutoModal({ produto, tipos, onClose, onSaved }) {
    const novo = !produto?.id;
    const [form, setForm] = useState({
        tipo: produto?.tipo || 'outro', nome: produto?.nome || '', marca: produto?.marca || '', observacoes: produto?.observacoes || '',
    });
    const [err, setErr] = useState('');
    const [saving, setSaving] = useState(false);
    const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));

    const guardar = async () => {
        setSaving(true); setErr('');
        try {
            if (novo) {
                await api.post('/produtos-quimicos', {
                    ...form,
                    // criado a partir de um PDF da pasta: fica logo ligado a ele
                    ...(produto?.evidencia_id ? { evidencia_id: produto.evidencia_id, tipo_documento: produto.tipo_documento } : {}),
                });
            } else {
                await api.put(`/produtos-quimicos/${produto.id}`, form);
            }
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao guardar.'); }
        finally { setSaving(false); }
    };

    return (
        <LiquidDialog style={overlay} onClick={onClose} onClose={onClose}>
            <div className="equipment-dialog equipment-form-dialog" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
                <div className="equipment-dialog-header">
                    <h3 style={{ margin: 0 }}>{novo ? 'Novo produto químico' : `Editar — ${produto.nome}`}</h3>
                    <button type="button" onClick={onClose} className="equipment-dialog-close" aria-label="Fechar"><OrcamentoIcon name="close" fallback="✕" /></button>
                </div>
                <div className="equipment-dialog-body">
                {produto?.evidencia_id && (
                    <div style={{ ...nota, marginBottom: 12 }}>O PDF «{produto.evidencia_titulo}» fica ligado a este produto como <b>{DOC_LABEL[produto.tipo_documento]}</b>.</div>
                )}
                <div className="equipment-dialog-grid">
                    <div style={{ gridColumn: '1 / -1' }}>
                        <label data-liquid-label="true" style={lbl}>Tipo</label>
                        <select value={form.tipo} onChange={e => upd('tipo', e.target.value)} style={{ ...inp, width: '100%' }}>
                            {tipos.map(t => <option key={t.valor} value={t.valor}>{t.label}</option>)}
                        </select>
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Nome do produto *</label>
                        <input value={form.nome} onChange={e => upd('nome', e.target.value)} style={{ ...inp, width: '100%' }} placeholder="Ex.: Soudaflex 40FC" />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Marca / fabricante *</label>
                        <input value={form.marca} onChange={e => upd('marca', e.target.value)} style={{ ...inp, width: '100%' }} placeholder="Ex.: Soudal" />
                    </div>
                    <div style={{ gridColumn: '1 / -1' }}>
                        <label data-liquid-label="true" style={lbl}>Onde é usado / observações</label>
                        <textarea value={form.observacoes} onChange={e => upd('observacoes', e.target.value)} rows={2} style={{ ...inp, width: '100%', resize: 'vertical' }} />
                    </div>
                </div>
                {err && <div style={{ color: '#e53e3e', marginTop: 10, fontSize: '0.85rem' }}>{err}</div>}
                </div>
                <div className="equipment-dialog-footer">
                    <button className="btn-secondary" onClick={onClose} style={btnSec}>Cancelar</button>
                    <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={btnPri}>{saving ? 'A guardar…' : 'Guardar'}</button>
                </div>
            </div>
        </LiquidDialog>
    );
}

/* ---------- Juntar FDS / ficha técnica a um produto ---------- */
function DocumentoModal({ produto, tipoDocumento, semProduto, onClose, onSaved }) {
    const [modo, setModo] = useState('carregar'); // carregar | pasta
    const [ficheiro, setFicheiro] = useState(null);
    const [dataDoc, setDataDoc] = useState('');
    const [evidenciaId, setEvidenciaId] = useState('');
    const [err, setErr] = useState('');
    const [saving, setSaving] = useState(false);
    // Os PDF da pasta com o nome deste produto no título vêm primeiro
    const nomeProduto = normalizar(produto.nome);
    const opcoes = [...semProduto].sort((a, b) =>
        Number(normalizar(b.titulo).includes(nomeProduto)) - Number(normalizar(a.titulo).includes(nomeProduto)));

    const guardar = async () => {
        setSaving(true); setErr('');
        try {
            if (modo === 'carregar') {
                if (!ficheiro) { setErr('Escolha o PDF.'); setSaving(false); return; }
                const fd = new FormData();
                fd.append('ficheiro', ficheiro);
                fd.append('tipo_documento', tipoDocumento);
                if (dataDoc) fd.append('data_documento', dataDoc);
                await api.post(`/produtos-quimicos/${produto.id}/documentos`, fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });
            } else {
                if (!evidenciaId) { setErr('Escolha o documento.'); setSaving(false); return; }
                await api.post(`/produtos-quimicos/${produto.id}/documentos/associar`, { evidencia_id: evidenciaId, tipo_documento: tipoDocumento });
            }
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao juntar o documento.'); }
        finally { setSaving(false); }
    };

    return (
        <LiquidDialog style={overlay} onClick={onClose} onClose={onClose}>
            <div className="equipment-dialog equipment-form-dialog" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
                <div className="equipment-dialog-header">
                    <h3 style={{ margin: 0 }}>{DOC_LABEL[tipoDocumento]} — {produto.nome}</h3>
                    <button type="button" onClick={onClose} className="equipment-dialog-close" aria-label="Fechar"><OrcamentoIcon name="close" fallback="✕" /></button>
                </div>
                <div className="equipment-dialog-body">
                <div className="equipment-dialog-options" style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
                    <button onClick={() => setModo('carregar')} style={modo === 'carregar' ? btnPri : btnSec}>Carregar PDF</button>
                    <button onClick={() => setModo('pasta')} disabled={!semProduto.length} style={modo === 'pasta' ? btnPri : btnSec}
                        title={semProduto.length ? '' : 'Não há PDF sem produto na pasta FDS'}>
                        Escolher um PDF da pasta FDS ({semProduto.length})
                    </button>
                </div>
                {modo === 'carregar' ? (
                    <div className="equipment-dialog-grid">
                        <div>
                            <label data-liquid-label="true" style={lbl}>PDF *</label>
                            <input type="file" accept="application/pdf,.pdf" onChange={e => setFicheiro(e.target.files[0] || null)} style={{ ...inp, width: '100%' }} />
                        </div>
                        <div>
                            <label data-liquid-label="true" style={lbl}>Data do documento</label>
                            <input type="date" value={dataDoc} onChange={e => setDataDoc(e.target.value)} style={{ ...inp, width: '100%' }} />
                        </div>
                        <div style={{ gridColumn: '1 / -1', fontSize: '0.8rem', color: '#64748b' }}>
                            Fica na pasta FDS da Conformidade Legal como «{DOC_LABEL[tipoDocumento]} — {produto.nome}» e os trabalhadores passam a vê-lo no telemóvel.
                        </div>
                    </div>
                ) : (
                    <div>
                        <label data-liquid-label="true" style={lbl}>PDF da pasta FDS</label>
                        <select value={evidenciaId} onChange={e => setEvidenciaId(e.target.value)} style={{ ...inp, width: '100%' }}>
                            <option value="">— escolher —</option>
                            {opcoes.map(d => <option key={d.id} value={d.id}>{d.titulo}{d.entidade ? ` (${d.entidade})` : ''}</option>)}
                        </select>
                    </div>
                )}
                {err && <div style={{ color: '#e53e3e', marginTop: 10, fontSize: '0.85rem' }}>{err}</div>}
                </div>
                <div className="equipment-dialog-footer">
                    <button className="btn-secondary" onClick={onClose} style={btnSec}>Cancelar</button>
                    <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={btnPri}>{saving ? 'A guardar…' : 'Juntar'}</button>
                </div>
            </div>
        </LiquidDialog>
    );
}

/* ---------- Painel ---------- */
export default function ProdutosQuimicosPainel({ onDocumentosAlterados, interno = false }) {
    const [dados, setDados] = useState(null);
    const [semProduto, setSemProduto] = useState([]);
    const [pesquisa, setPesquisa] = useState('');
    const [filtro, setFiltro] = useState('todos'); // todos | sem_fds | sem_ft
    const [editar, setEditar] = useState(null);
    const [documentacao, setDocumentacao] = useState(undefined);
    const [lote, setLote] = useState(false);
    const [juntar, setJuntar] = useState(null);    // { produto, tipoDocumento }
    const [tipoLigar, setTipoLigar] = useState({}); // evidencia_id → tipo escolhido
    const [erro, setErro] = useState('');

    const carregar = useCallback(async () => {
        try {
            const p = await api.get('/produtos-quimicos', { params: { _t: Date.now() } });
            const s = p.data.gestor
                ? await api.get('/produtos-quimicos/documentos-sem-produto').catch(() => ({ data: [] }))
                : { data: [] };
            setDados(p.data); setSemProduto(s.data || []); setErro('');
        } catch { setErro('Não foi possível carregar os produtos químicos.'); }
    }, []);
    useEffect(() => { carregar(); }, [carregar]);

    // Sempre que os documentos mudam, a tabela da pasta (em baixo) também
    const alterado = () => { carregar(); if (onDocumentosAlterados) onDocumentosAlterados(); };

    const apagar = async (p) => {
        const nDocs = p.documentos.length;
        if (!window.confirm(`Apagar o produto «${p.nome}»?${nDocs ? `\n\nOs ${nDocs} documento(s) ligados não se apagam: ficam na pasta FDS, sem produto.` : ''}`)) return;
        try { await api.delete(`/produtos-quimicos/${p.id}`); alterado(); }
        catch (e) { alert(e.response?.data?.error || 'Erro ao apagar.'); }
    };
    const retirar = async (p, d) => {
        if (!window.confirm(`Tirar «${d.titulo}» de «${p.nome}»?\n\nO PDF continua na pasta FDS.`)) return;
        try { await api.delete(`/produtos-quimicos/${p.id}/documentos/${d.id}`); alterado(); }
        catch (e) { alert(e.response?.data?.error || 'Erro ao retirar.'); }
    };
    const ligar = async (doc, produtoId) => {
        if (!produtoId) return;
        try {
            await api.post(`/produtos-quimicos/${produtoId}/documentos/associar`, { evidencia_id: doc.id, tipo_documento: tipoLigar[doc.id] || tipoPeloTitulo(doc.titulo) });
            alterado();
        } catch (e) { alert(e.response?.data?.error || 'Erro ao ligar o documento.'); }
    };

    if (erro) return <div style={{ ...caixa, color: '#b91c1c' }}>{erro}</div>;
    if (!dados) return <div style={caixa}>A carregar os produtos químicos…</div>;

    const produtos = dados.produtos || [];
    const semTipo = (p, tipo) => !p.documentos.some(d => d.tipo_documento === tipo && !d.requer_atualizacao);
    const nSemFds = produtos.filter(p => semTipo(p, 'fds')).length;
    const nSemFt = produtos.filter(p => semTipo(p, 'ficha_tecnica')).length;
    const t = normalizar(pesquisa.trim());
    const visiveis = produtos.filter(p => (filtro === 'todos' || (filtro === 'sem_fds' ? semTipo(p, 'fds') : semTipo(p, 'ficha_tecnica')))
        && (!t || normalizar(`${p.nome} ${p.marca} ${p.tipo_label} ${p.registado_por_nome}`).includes(t)));

    const celulaDocs = (p, tipo) => {
        const docs = p.documentos.filter(d => d.tipo_documento === tipo);
        return (
            <td style={{ minWidth: 150 }}>
                {docs.map(d => (
                    <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 3 }}>
                        <button onClick={() => abrirBlob(`/produtos-quimicos/documentos/${d.id}`)} style={linkDoc} title={d.nome_original || d.titulo}>
                            <OrcamentoIcon name="document" fallback="📄" /> {DOC_LABEL[tipo]}{d.requer_atualizacao ? ' · Atualização por pedir' : ''}{d.data_documento ? ` · ${fmtData(d.data_documento)}` : ''}
                        </button>
                        {d.fonte_url && /^https?:\/\//i.test(d.fonte_url) && <a href={d.fonte_url} target="_blank" rel="noreferrer" title="Fonte original do documento" style={{ fontSize: 11 }}>Fonte</a>}
                        {dados.gestor && <button className="pq-action-button pq-action-icon" onClick={() => retirar(p, d)} title="Tirar deste produto (o PDF fica na pasta)" aria-label={`Desassociar ${DOC_LABEL[tipo]} de ${p.nome}`}><OrcamentoIcon name="close" fallback="✕" /></button>}
                    </div>
                ))}
                {!docs.length && <span data-liquid-tone={liquidTone('#fef3c7')} data-liquid-badge="true" style={{ ...badge, background: '#fef3c7', color: '#92400e' }}>Em falta</span>}{' '}
                {dados.gestor && <button className="pq-action-button" onClick={() => setJuntar({ produto: p, tipoDocumento: tipo })}><OrcamentoIcon name="plus" fallback="+" /> {DOC_LABEL[tipo]}</button>}
            </td>
        );
    };

    return (
        <div className={`pq-panel ${interno ? "pq-internal-panel" : ""}`} style={caixa}>
            <div className="pq-panel-header" style={{ display: 'flex', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap', marginBottom: 10 }}>
                <div style={{ flex: 1, minWidth: 280 }}>
                    <h3 style={{ margin: '0 0 4px', fontSize: '1.05rem', color: '#1e293b' }}><OrcamentoIcon name="test" fallback="🧪" /> Produtos químicos em uso ({produtos.length})</h3>
                    <div style={{ fontSize: '0.82rem', color: '#64748b', lineHeight: 1.45 }}>
                        {interno
                            ? 'Os registos e documentos são os mesmos do Sistema Integrado. As alterações ficam disponíveis nos dois locais.'
                            : 'Inventário partilhado com Equipamentos e com os trabalhadores. As FDS e fichas técnicas ficam na pasta de evidências do Sistema Integrado.'}
                    </div>
                </div>
                {dados.gestor && <button className="btn-secondary" disabled={!nSemFds && !nSemFt} onClick={() => setLote(true)}><OrcamentoIcon name="send" fallback="↗" /> Pedir documentos em lote</button>}
                {dados.gestor && <button className="btn-secondary" onClick={() => setDocumentacao(null)} style={btnSec}>Histórico de pedidos</button>}
                <button className="btn-primary" onClick={() => setEditar({})} style={btnPri}>+ Novo produto</button>
            </div>

            <div className="pq-panel-filters" style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
                <input value={pesquisa} onChange={e => setPesquisa(e.target.value)} placeholder="Procurar produto, marca, quem registou…" style={{ ...inp, minWidth: 260 }} />
                {[['todos', `Todos (${produtos.length})`], ['sem_fds', `FDS em falta / a atualizar (${nSemFds})`], ['sem_ft', `Ficha técnica em falta (${nSemFt})`]].map(([k, l]) => (
                    <button key={k} aria-pressed={filtro === k} onClick={() => setFiltro(k)} style={filtro === k ? btnPri : btnSec}>{l}</button>
                ))}
            </div>

            <div className="pq-products-table" style={{ overflowX: 'auto' }}>
                <table className="standard-table">
                    <thead>
                        <tr>
                            <th>Produto</th>
                            <th>Registado por</th>
                            <th>FDS</th>
                            <th>Ficha técnica</th>
                            <th style={{ textAlign: 'right' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visiveis.length === 0 && (
                            <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8', padding: '24px 0' }}>
                                {produtos.length ? 'Nenhum produto com este filtro.' : 'Ainda não há produtos registados.'}
                            </td></tr>
                        )}
                        {visiveis.map(p => (
                            <tr key={p.id}>
                                <td>
                                    <div style={{ fontWeight: 700 }}>{p.nome}</div>
                                    <div style={{ fontSize: '0.8rem', color: '#64748b' }}>
                                        {p.marca} · {p.tipo_label}
                                        {p.tem_foto && <> · <button onClick={() => abrirBlob(`/produtos-quimicos/${p.id}/foto`)} style={linkDoc}><LiquidText>📷 rótulo</LiquidText></button></>}
                                    </div>
                                    {p.email_documentacao && <div style={{ fontSize: '0.76rem', color: '#475569' }}>{p.email_documentacao}</div>}
                                    {p.observacoes && <div style={{ fontSize: '0.76rem', color: '#94a3b8' }}>{p.observacoes.substring(0, 100)}</div>}
                                </td>
                                <td style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                                    {p.registado_por_nome || '—'}
                                    <div style={{ color: '#94a3b8', fontSize: '0.76rem' }}>{fmtData(p.criado_em)}</div>
                                </td>
                                {celulaDocs(p, 'fds')}
                                {celulaDocs(p, 'ficha_tecnica')}
                                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                    {dados.gestor && <button className="pq-action-button" onClick={() => setDocumentacao(p)}><OrcamentoIcon name="mail" fallback="✉" /> Documentação / email</button>}{' '}
                                    {(dados.gestor || p.pode_editar) && <button className="pq-action-button" onClick={() => setEditar(p)}><OrcamentoIcon name="edit" fallback="✎" /> Editar</button>}{' '}
                                    {(dados.gestor || p.pode_editar) && <button className="pq-action-button pq-action-danger" onClick={() => apagar(p)} title="Apagar (duplicados, enganos)" aria-label={`Apagar ${p.nome}`}><DeleteIcon /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* PDF que já estavam na pasta e ainda não têm produto */}
            {dados.gestor && semProduto.length > 0 && (
                <details style={{ marginTop: 14 }} open={produtos.length === 0}>
                    <summary style={{ cursor: 'pointer', fontWeight: 700, color: '#334155', fontSize: '0.9rem' }}><LiquidText>
                        📎 </LiquidText>{semProduto.length} PDF desta pasta ainda sem produto — ligue-os a um produto ou crie o produto a partir deles
                    </summary>
                    <div style={{ overflowX: 'auto', marginTop: 8 }}>
                        <table className="standard-table">
                            <thead><tr><th>Documento</th><th>Entidade</th><th>É</th><th>Ligar a um produto</th><th></th></tr></thead>
                            <tbody>
                                {semProduto.map(d => (
                                    <tr key={d.id}>
                                        <td style={{ fontWeight: 600 }}><LiquidText>{d.titulo}</LiquidText></td>
                                        <td style={{ fontSize: '0.84rem' }}>{d.entidade || '—'}</td>
                                        <td>
                                            <select value={tipoLigar[d.id] || tipoPeloTitulo(d.titulo)} onChange={e => setTipoLigar(x => ({ ...x, [d.id]: e.target.value }))} style={inp}>
                                                <option value="fds">FDS</option>
                                                <option value="ficha_tecnica">Ficha técnica</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select value="" onChange={e => ligar(d, e.target.value)} style={{ ...inp, maxWidth: 240 }} disabled={!produtos.length}>
                                                <option value="">{produtos.length ? '— escolher produto —' : '(ainda não há produtos)'}</option>
                                                {produtos.map(p => <option key={p.id} value={p.id}>{p.nome} ({p.marca})</option>)}
                                            </select>
                                        </td>
                                        <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                            <button onClick={() => abrirEvidencia(d.id)} style={btnMini}>Abrir</button>{' '}
                                            <button onClick={() => setEditar({
                                                nome: nomePeloTitulo(d.titulo), marca: d.entidade || '', tipo: 'outro',
                                                evidencia_id: d.id, evidencia_titulo: d.titulo, tipo_documento: tipoLigar[d.id] || tipoPeloTitulo(d.titulo),
                                            })} style={btnMini}>Criar produto</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </details>
            )}

            {lote && <ProdutoDocumentacaoLoteModal onClose={() => setLote(false)} onSaved={alterado} />}
            {documentacao !== undefined && <ProdutoDocumentacaoModal produto={documentacao} onClose={() => setDocumentacao(undefined)} onSaved={alterado} />}
            {editar && <ProdutoModal produto={editar} tipos={dados.tipos || []} onClose={() => setEditar(null)} onSaved={alterado} />}
            {juntar && <DocumentoModal produto={juntar.produto} tipoDocumento={juntar.tipoDocumento} semProduto={semProduto}
                onClose={() => setJuntar(null)} onSaved={alterado} />}
        </div>
    );
}

/* ---------- estilos (os da página dos Requisitos Legais) ---------- */
const caixa = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, marginBottom: 16 };
const lbl = { display: 'block', fontSize: '0.74rem', color: '#64748b', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.03em' };
const inp = { padding: '7px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box' };
const badge = { padding: '3px 10px', borderRadius: 12, fontSize: '0.76rem', fontWeight: 600, whiteSpace: 'nowrap' };
const btnSec = { padding: '7px 14px', border: '1px solid #cbd5e1', background: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', color: '#334155' };
const btnPri = { padding: '7px 14px', border: '1px solid #3182ce', background: '#3182ce', color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem' };
const btnMini = { ...btnSec, padding: '3px 9px', fontSize: '0.76rem' };
const btnX = { border: 'none', background: 'transparent', color: '#94a3b8', cursor: 'pointer', fontSize: '0.8rem', padding: '0 4px' };
const linkDoc = { border: 'none', background: 'none', padding: 0, color: '#2b6cb0', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600, textAlign: 'left' };
const nota = { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', borderRadius: 8, padding: '8px 10px', fontSize: '0.84rem' };
const overlay = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '40px 16px', overflowY: 'auto' };
